import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

const LABEL = { renovar: "Renovação", cortesia: "Dias de cortesia", ressincronizar: "Ressincronização", editar: "Edição", criar_teste: "Teste criado", ativar: "Teste ativado", criar_cliente: "Cliente criado", corrigir_link_app: "Link do app corrigido", bouquets: "Bouquets", deletar: "Cliente deletado", macs_apps: "MACs dos apps" };

const describe = (a) => {
  const d = a.details || {};
  if (a.action === "renovar" || a.action === "ativar") return `${d.package} · ${d.credits_used ?? d.credits} créd.`;
  if (a.action === "corrigir_link_app") return `${d.app}: ${(d.antes || "").slice(-10)} → ${(d.depois || "").slice(-10)}`;
  if (a.action === "macs_apps") return Object.entries(d).map(([k, v]) => `${k}: ${v.de || "—"} → ${v.para || "—"}`).join(" | ");
  if (a.action === "bouquets") return `${d.de} → ${d.para}`;
  if (a.action === "deletar") return `${d.plan || ""} · venc. ${d.due || "—"}`;
  if (a.action === "cortesia") return `+${d.days} dia(s)`;
  if (a.action === "editar") return Object.entries(d).map(([k, v]) => (v && typeof v === "object" ? `${k}: ${v.de ?? "—"} → ${v.para}` : k)).join(" | ");
  if (a.action === "criar_teste" || a.action === "criar_cliente") return d.package;
  return "";
};

export const ActionHistory = ({ clientId, refreshKey, showClient }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/panel-actions", { params: clientId ? { client_id: clientId } : {} }).then((r) => setRows(r.data));
  }, [clientId, refreshKey]);
  if (!rows) return <div data-testid="actions-loading" className="text-xs text-slate-500">Carregando...</div>;
  if (!rows.length) return <div data-testid="actions-empty" className="text-xs text-slate-500">Nenhuma ação no SYSLOG ainda.</div>;
  return (
    <div data-testid="actions-history" className="space-y-1.5">
      {rows.map((a) => (
        <div key={a.id} data-testid={`action-${a.id}`} className="flex items-start gap-2 rounded-lg border border-[#1F293D] bg-[#111827] px-3 py-2 text-xs">
          {a.ok ? <CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0 text-emerald-400" /> : <XCircle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-red-400" />}
          <div className="min-w-0 flex-1">
            <div className="flex justify-between gap-2">
              <span className="font-semibold text-slate-200">{LABEL[a.action] || a.action}{showClient && (a.name || a.panel_user) ? ` · ${a.name || a.panel_user}` : ""}</span>
              <span className="shrink-0 font-mono text-slate-500">{new Date(a.at).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}</span>
            </div>
            <div className="truncate text-slate-400">{[a.operator, a.account, showClient && a.panel_user, describe(a)].filter(Boolean).join(" · ")}</div>
            {!a.ok && <div className="text-red-400/90">{a.error}</div>}
          </div>
        </div>
      ))}
    </div>
  );
};
